import { useCallback } from 'react'

import { useInfiniteQuery } from '@tanstack/react-query'

import { mockFetchAcquiredModels } from '../mockData'

const PER_PAGE = 10

/**
 * Paginated feed of the models the user has acquired, backing the picker grid.
 * Mirrors useGetLibraryItems so the grid behaves like the library list; the fetcher is
 * still mocked (see mockData.js) until the list endpoint lands.
 */
export default function useAcquiredModels(isLoggedIn, keywords) {
  const normalizedKeywords = (keywords ?? '').trim()

  const {
    data,
    hasNextPage: queryHasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    isInitialLoading,
    isError,
  } = useInfiniteQuery({
    queryKey: ['acquiredModels', normalizedKeywords],
    queryFn: ({ pageParam = 1 }) => mockFetchAcquiredModels({
      page: pageParam,
      perPage: PER_PAGE,
      keywords: normalizedKeywords,
    }),
    getNextPageParam: (lastPage, allPages) => {
      const { currentPage, totalPages } = lastPage.meta
      return currentPage < totalPages ? allPages.length + 1 : undefined
    },
    initialPageParam: 1,
    enabled: isLoggedIn === true,
  })

  const handleLoadMore = useCallback(() => {
    fetchNextPage()
  }, [fetchNextPage])

  return {
    items: data?.pages?.flatMap(page => page.items) ?? [],
    meta: data?.pages?.slice(-1)[0]?.meta,
    hasNextPage: queryHasNextPage ?? false,
    handleLoadMore,
    isFetchingNextPage,
    isLoading: isInitialLoading,
    isError,
  }
}
